import { API_FETCH, urlParamAppendObject } from '../../../utils';

export const CampaignSubmit = (token, data) => {
  const _reqHeader = new Headers();
  _reqHeader.append('Content-Type', 'application/json');
  _reqHeader.append('Authorization', `Bearer ${token}`);

  const _reqOpts = {
    method: 'POST',
    headers: _reqHeader,
    body: JSON.stringify(data),
    redirect: 'follow',
  };
  return new Promise((resolve, reject) => {
    fetch(API_FETCH(`/brand/campaign/reviewcampaign`), _reqOpts)
      .then((response) => response.json())
      .then((result) => resolve(result))
      .catch((error) => {
        console.log('error while getting Campaigns =>', error);
        reject(error);
      });
  });
};
